import { Component, OnInit, Output, EventEmitter, Input, OnDestroy } from '@angular/core';
import { Destroy, sort } from '@kpd/framework-ngx';
import { map, takeUntil, tap } from 'rxjs/operators';
import { Tenant } from '../models/tenant';
import { TenantService } from '../services/tenant.service';

@Component({
  selector: 'app-tenants-menu-item',
  template: `
    <div class="dropdown__spinner" *ngIf="isLoading"><kpd-spinner></kpd-spinner></div>
    <div class="header__menu flex-row" (click)="$event.preventDefault(); $event.stopPropagation()">
      <input
        [(ngModel)]="searchInput"
        (ngModelChange)="searchTenants()"
        style="margin-left: 12px"
        [placeholder]="'Search' | translate"
      />
    </div>
    <div class="header__menu flex-row" *ngFor="let tenant of filteredTenants">
      <button class="dropdown--menu__item" (click)="onTenantSelected(tenant)" translate>
        <div class="radio-button">
          <input type="radio" name="radio" [checked]="tenant.name === tenantName" />
          <span class="radio-button__circle"></span>
          <span class="radio-button__label">
            {{ tenant.description }}
          </span>
        </div>
      </button>
    </div>
  `,
})
export class TenantsMenuItemComponent implements OnInit, OnDestroy {
  @Destroy()
  destroy: any;
  @Output()
  tenantSelected = new EventEmitter<Tenant>();
  @Input()
  tenantName: string;
  allTenants: Tenant[] = [];
  filteredTenants: Tenant[] = [];
  isLoading: boolean;
  searchInput: string = '';

  constructor(private tenantService: TenantService) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.tenantService
      .getAllTenantsForCurrentUser()
      .pipe(
        map((result) => sort(result, { name: 'name' })),
        tap((results) => {
          this.allTenants = results;
          this.filteredTenants = results;
          this.isLoading = false;
        }),
        takeUntil(this.destroy),
      )
      .subscribe();
  }

  searchTenants(): void {
    this.filteredTenants = this.allTenants.filter(
      (t) =>
        t.name.toLowerCase().includes(this.searchInput.toLowerCase()) ||
        (t.description && t.description.toLowerCase().includes(this.searchInput.toLowerCase())),
    );
  }

  onTenantSelected(tenant: Tenant): void {
    this.tenantSelected.emit(tenant);
  }

  ngOnDestroy(): void {}
}
